{
  "marketing_list": {
    "info": {
      "update_aria_label": "Mettre à jour les informations de la liste",
      "list_suffix": "liste, ",
      "contacts_total": "contacts au total, dernière mise à jour le"
    },
    "form": {
      "name_required": "Veuillez nommer votre liste",
      "category_required": "Veuillez sélectionner une catégorie",
      "list_name_label": "Nom de la liste *",
      "list_name_placeholder": "Nom de la liste",
      "create_header": "Créer une liste marketing",
      "update_header": "Mettre à jour la liste marketing"
    },
    "header": {
      "archived_label": "archivée"
    }
  },
  "actions": {
    "add_contact": "Ajouter un contact",
    "missing_field": "Champ manquant",
    "request_contacts": "Demander des contacts",
    "add_to_list": "Ajouter à la liste",
    "log_activity": "Enregistrer une nouvelle activité",
    "export_selected": "Exporter la sélection",
    "download_export": "Télécharger l'export",
    "clean_list": "Nettoyer la liste",
    "removed_history": "Historique supprimé",
    "add_comment": "Ajouter un commentaire",
    "import_contacts": "Importer des contacts",
    "export_contacts": "Exporter des contacts",
    "download_export_file": "Télécharger le fichier d'export",
    "archive_list": "Archiver la liste",
    "menu": "Actes",
    "exclusion_rule_list": "Liste de règles d'exclusion",
    "past_exports": "Exportations passées"
  },
  "excluded_contacts": {
    "alert_message": "Il y a {{count}} contacts dans cette liste avec des règles d'exclusion correspondantes.",
    "show_excluded_link": "Montrez-moi les contacts exclus."
  },
  "filters": {
    "title": "Filtrer",
    "contact_status": {
      "label": "Statut du contact",
      "all": "Tous",
      "bounced": "Rebondis",
      "unengaged": "Non engagés",
      "marketing_excluded": "Exclus du marketing"
    },
    "consent_status": {
      "label": "Statut du consentement",
      "legitimate_interest_tooltip": "Vous pouvez contacter la personne sans consentement explicite en raison d'une relation existante.",
      "values": {
        "consent_given": "Consentement donné",
        "consent_not_given": "Consentement non donné",
        "legitimate_interest": "Intérêt légitime",
        "user_unsubscribed": "Utilisateur désabonné"
      }
    },
    "tags": {
      "label": "Étiquettes",
      "placeholder": "Tapez ou sélectionnez des étiquettes"
    },
    "added_by": {
      "label": "Ajouté par",
      "placeholder": "Tapez le nom ou l'email"
    },
    "missing_field": "Champ manquant",
    "active_filters_aria": "{{count}} filtres sont actifs",
    "apply": "Appliquer",
    "clear_filters": "Effacer les filtres",
    "order_by": "Trier par",
    "order_by_options": {
      "created_at_asc": "créé à asc",
      "created_at_desc": "créé à desc",
      "name_asc": "nom asc",
      "name_desc": "nom desc",
      "updated_at_asc": "mis à jour à asc",
      "updated_at_desc": "mis à jour à desc"
    }
  },
  "table": {
    "all_contacts_selected": "Tous les {{count}} contacts sélectionnés",
    "add_to_list_success": "Demande envoyée. Cela peut prendre quelques minutes pour voir tous les contacts dans la liste cible",
    "columns": {
      "contact": "Contact",
      "company": "Entreprise",
      "consent_status": "Statut du consentement",
      "tags": "Étiquettes",
      "location": "Localisation",
      "last_interaction": "Dernière interaction",
      "added_date": "Date d'ajout",
      "added_by": "Ajouté par"
    },
    "consent_not_given": "Consentement non donné",
    "missing_required_fields": "Champs obligatoires manquants",
    "headers": {
      "list": "Liste",
      "category": "Catégorie",
      "created_by": "Créé par",
      "last_updated": "Dernière mise à jour"
    }
  },
  "sync": {
    "sync_contacts": "Synchroniser les contacts",
    "sync_with": "Synchroniser avec {{type}}",
    "sync_list": "Synchroniser la liste",
    "audience": "Audience",
    "select_audience": "Sélectionner une audience",
    "sync": "Synchroniser",
    "not_available_yet": "Pas encore disponible",
    "connected_to": "Connecté à {{type}}",
    "ems_name": "Nom EMS",
    "last_synced": "Dernière synchronisation",
    "not_synced_yet": "Pas encore synchronisé",
    "disconnect_confirmation": "Êtes-vous sûr de vouloir déconnecter cette liste de {{type}}",
    "disconnect_from": "Déconnecter de {{type}}",
    "sync_failed": "Échec de la synchronisation : ",
    "contacts_need_attention": "{{count}} contacts nécessitent votre attention avant de pouvoir être synchronisés.",
    "list_out_of_sync": "La liste n'est pas synchronisée.",
    "syncing_in_progress": "Synchronisation de la liste en cours, cela peut prendre quelques minutes..."
  },
  "category": {
    "label": "Catégorie",
    "any": "Tous"
  },
  "contact_request": {
    "description": "Partagez cette URL pour demander à d'autres d'ajouter leurs contacts à cette liste."
  },
  "categories": {
    "client_alert": "Alerte client",
    "country_group": "Groupe de pays",
    "event_invite": "Invitation à un événement",
    "general_marketing": "Marketing général",
    "newsletter": "Bulletin d'information",
    "office_lists": "Listes de bureau",
    "other": "Autre",
    "practice_area": "Domaine de pratique",
    "sector_or_industry": "Secteur ou industrie",
    "subscribers": "Abonnés",
    "webinar_invite": "Invitation au webinaire"
  },
  "status": {
    "archived": "Archivé"
  },
  "ems": {
    "setup_title": "Configuration EMS"
  }
}
